(() => {
  const configElement = document.getElementById('parfumae-badge-config');
  if (!configElement || customElements.get('parfumae-product-badges')) return;
  const config = JSON.parse(configElement.textContent);
  let rankings;

  async function loadRanking(source) {
    if (!source.url) return { ...source, handles: new Set() };
    const url = new URL(source.url, window.location.origin);
    url.search = '';
    url.searchParams.set('sort_by', source.sort);
    url.searchParams.set('section_id', 'product-badge-data');
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Badge data unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = html.querySelector('[data-product-badge-handles]');
      if (!data) throw new Error('Badge data missing');
      const handles = JSON.parse(data.textContent);
      if (!Array.isArray(handles)) throw new Error('Invalid badge data');
      return { ...source, handles: new Set(handles.slice(0, 20)) };
    } catch (error) {
      // A failed source must never give a product an unverified badge.
      return { ...source, handles: new Set() };
    }
  }

  customElements.define('parfumae-product-badges', class extends HTMLElement {
    async connectedCallback() {
      // Share requests across all cards, including cards inserted by filtering,
      // pagination, recommendations, or the theme editor.
      rankings ||= Promise.all(config.map(loadRanking));
      const sources = await rankings;
      if (!this.isConnected) return;
      this.replaceChildren();
      for (const source of sources) {
        if (!source.handles.has(this.dataset.handle)) continue;
        const badge = document.createElement('span');
        badge.className = 'badge badge--primary';
        badge.textContent = source.label;
        if (source.background) badge.style.backgroundColor = source.background;
        this.append(badge);
      }
    }
  });
})();
